import React, { FC } from "react";

import Svg from "./Svg";

interface Props {
  width: string;
  height: string;
  className?: string;
}

const Pinterest: FC<Props> = ({ className, height, width }) => (
  <Svg
    className={className}
    height={height}
    width={width}
    viewBox="0 0 244 244"
    title="Pinterest icon"
  >
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M244 122a122 122 0 11-244 0 122 122 0 01244 0" />
      <path
        fill="#BD081C"
        d="M122 0a122 122 0 00-44 236c-2-10-2-25 0-35l14-61s-3-7-3-18c0-17 9-30 22-30 10 0 15 8 15 17 0 11-7 27-10 41-3 12 6 22 18 22 22 0 38-23 38-56 0-29-21-49-51-49-34 0-55 26-55 53 0 10 4 21 9 27 1 2 2 3 1 4l-3 14c-1 2-2 2-4 1-15-7-25-29-25-47 0-38 28-74 81-74 42 0 75 30 75 71 0 42-27 76-63 76-13 0-24-7-28-14l-8 29c-3 10-10 23-15 32A122 122 0 10122 0"
      />
    </g>
  </Svg>
);

export default Pinterest;
